import * as React from "react";
import {cx} from "emotion";

import "./step-2-routes.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {equalDeep}      from "@Common/utils/objects";

import {isDevQuan}     from "../../../../../../debug/is-dev-quan";
import {Header}        from "../../common/header/header";
import {groupSections} from "../common/group-sections";

import {ListNameSection}  from "./list-name-section/list-name-section";
import {RoutesSection}    from "./routes-section/routes-section";
import {UspsSection}      from "./usps-section/usps-section";

export const Step2Routes = ({state, next}) => cs(
    consumeContext("apis"),
    consumeContext("company"),
    //["isMapBased", ({company}, next) => next(company.prefs?.enableMapBasedMailingSupport)],
    ["routesSection", ({}, next) => RoutesSection({
        allRoutes: state.value?.allRoutes,
        next,
    })],
    ["listNameSection", ({}, next) => ListNameSection({next})],
    ({apis, routesSection, listNameSection}) => next({
        ready: state.value?.allRoutes,
        prepare: async (searchRequest) => {
            if (equalDeep(state.value?.searchRequest, searchRequest)) {
                return;
            }

            routesSection.reset();

            const {allRoutes, searchRequestServerKey} = await apis.next.mailing.eddm.searchEddmList({search: searchRequest});
            state.change((_) => ({
                allRoutes,
                searchRequest,
                searchRequestServerKey,
            }));
        },
        setUnselecteds: routesSection.setUnselecteds,
        render: ({onBack, onComplete}) => cs(
            ["groupedSections", ({}, next) => next(groupSections([routesSection, listNameSection]))],
            ["showErrors", (_, next) => UseState({next})],
            ["defaultListName", (_, next) => next("Neighborhood Mailing")],
            ({groupedSections, defaultListName, showErrors}) => (
                <div className="step-2-routes-8dx">
                    {Header({
                        icon: require("../../../../mailing-icons/listtype-eddm.png"),
                        title: "Neighborhood Search",
                        subTitle: "Reach every residence in your selected neighborhoods.",
                    })}

                    <div className="content">

                        {PrevStep({
                            title: "Select Neighborhoods on Map",
                            onClick: () => onBack({selectedRoutes: routesSection.getSelecteds()}),
                        })}

                        {routesSection.render({showErrors: showErrors.value})}

                        {/** !isMapBased && UspsSection({}) */}

                        {listNameSection.render({
                            showErrors: showErrors.value,
                            defaultListName,
                        })}
                    </div>

                    <div className="footer">
                        <button {...{
                            className: "cancel",
                            onClick: () => onBack({selectedRoutes: routesSection.getSelecteds()}),
                            "xd-qa-type": "button",
                            "xd-qa-name": "Neighborhood Search Back",
                        }}>
                            Back
                        </button>

                        {cs(
                            ["submitting", (_, next) => UseState({next})],
                            ({submitting}) => (
                                <button {...{
                                    className: cx("next", {
                                        disabled: !groupedSections.valid,
                                    }),
                                    disabled: submitting.value,
                                    onClick: async () => {
                                        if (submitting.value) {
                                            return;
                                        }
                                        if (!groupedSections.valid) {
                                            if (!showErrors.value) {
                                                showErrors.onChange(true);
                                            }
                                            groupedSections.highlightErrors();
                                        } else {
                                            submitting.onChange(true);
                                            await onComplete({
                                                searchRequestServerKey: state.value.searchRequestServerKey,
                                                routes  : routesSection.getSubmitData(),
                                                listName: listNameSection.getSubmitData() || defaultListName,
                                            });
                                            submitting.onChange(false);
                                        }
                                    },
                                    "xd-qa-type": "button",
                                    "xd-qa-name": "Neighborhood Search Complete",
                                }}>
                                    Complete
                                </button>
                            )
                        )}
                    </div>
                </div>
            ),
        ),
    })
);

const PrevStep = ({title, onClick}) => (
    <div className="prev-section">

        <div className="title" xd-qa-type="label" xd-qa-name={"Neighborhood Search "+title}>
            {title}
        </div>
        <a className="edit" onClick={onClick} xd-qa-type="link" xd-qa-name={"Neighborhood Search Edit"}>
            Edit
        </a>
    </div>
);
